/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much water should I drink?`)
};

const es_water_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánta agua debería beber?`)
};

const de_water_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viel Wasser sollte ich trinken?`)
};

const nl_water_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel water moet ik drinken?`)
};

const fr_water_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien d'eau devrais-je boire ?`)
};

const it_water_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanta acqua dovrei bere?`)
};

const pt_br2_water_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanta água devo beber?`)
};

const pt_water_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanta água devo beber?`)
};

const ja_water_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水はどのくらい飲むべきですか?`)
};

const zh_water_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我每天应该喝多少水？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_faq_q1", locale)
	if (locale === "en") return en_water_faq_q1(inputs)
	if (locale === "es") return es_water_faq_q1(inputs)
	if (locale === "de") return de_water_faq_q1(inputs)
	if (locale === "nl") return nl_water_faq_q1(inputs)
	if (locale === "fr") return fr_water_faq_q1(inputs)
	if (locale === "it") return it_water_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_water_faq_q1(inputs)
	if (locale === "pt") return pt_water_faq_q1(inputs)
	if (locale === "ja") return ja_water_faq_q1(inputs)
	return zh_water_faq_q1(inputs)
};